import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";
import {
  Client,
  ClientInfo,
  ListResponse,
  NewClient,
  Response,
} from "types/apiTypes";
import { ClientTags, RequestMethods } from "types/enums";
import { Query } from "../types";

const path = "/clients";

export const clientsApi = createApi({
  reducerPath: "clientsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(ClientTags),
  endpoints: (builder) => ({
    getClients: builder.query<ListResponse<Client>, Query>({
      query: (params) => ({
        url: path,
        method: RequestMethods.GET,
        params,
      }),
      providesTags: [ClientTags.clients],
      keepUnusedDataFor: 0,
    }),

    addClient: builder.mutation<Client, NewClient>({
      query: (body) => ({
        url: path,
        method: RequestMethods.POST,
        body,
      }),
    }),

    updateClient: builder.mutation<Client, ClientInfo & { client_id: string }>({
      query: ({ client_id, ...body }) => ({
        url: `${path}/${client_id}`,
        method: RequestMethods.PATCH,
        body,
      }),
      invalidatesTags: [ClientTags.clients],
    }),

    removeClient: builder.mutation<Response, string>({
      query: (client_id) => ({
        url: `${path}/${client_id}`,
        method: RequestMethods.DELETE,
      }),
      invalidatesTags: [ClientTags.clients],
    }),
  }),
});

export const {
  useGetClientsQuery,
  useAddClientMutation,
  useUpdateClientMutation,
  useRemoveClientMutation,
} = clientsApi;
